import {
  useElementTextOverflow,
  OverflowDirection,
} from 'helpers/useElementTextOverflow';
import styles from './Comment.module.scss';
import { BrightTooltip } from 'components/tooltips/BrightTooltip';
import EditIcon from 'assets/icons/edit.svg?react';
import PlusIcon from 'assets/icons/plus_24.svg?react';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { useState } from 'react';
import { UpdateTemplateComment } from './UpdateTemplateComment/UpdateTemplateComment';

export const Comment = (props: { text: string | null; templateId: number }) => {
  const i18n = useScopedTranslation('Page.Templates.VersionHistoryModal');
  const [contentRef, isOverflowing] = useElementTextOverflow<HTMLDivElement>(
    OverflowDirection.Vertical,
  );

  const [isUpdateCommentOpened, setIsUpdateCommentOpened] = useState(false);

  return (
    <>
      {props.text ? (
        <BrightTooltip
          title={<div className={styles.toolTip}>{props.text}</div>}
          placement="bottom-start"
          followCursor={true}
          disableHoverListener={!isOverflowing}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [-5, 7],
                },
              },
            ],
          }}
        >
          <div
            className={styles.commentContainer}
            onClick={() => setIsUpdateCommentOpened(true)}
          >
            <div ref={contentRef} className={styles.commentContent}>
              {props.text}
            </div>
            <EditIcon className={styles.editIcon} />
          </div>
        </BrightTooltip>
      ) : (
        <div className={styles.addComment} onClick={() => setIsUpdateCommentOpened(true)}>
          <PlusIcon />
          <div>{i18n.t('add_comment')}</div>
        </div>
      )}
      <UpdateTemplateComment
        templateId={props.templateId}
        currentComment={props.text}
        isOpen={isUpdateCommentOpened}
        setIsOpen={setIsUpdateCommentOpened}
      />
    </>
  );
};
